import React, { useCallback, useRef, useState } from "react";
import { AutoPredictionsContext, AutoPredictionsContextType } from "./AutoPredictionsContext";

export const AutoPredictionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const triggerRef = useRef<(() => Promise<void>) | null>(null);
    const boxDrawnCallbackRef = useRef<(() => void) | null>(null);
    const [isAutoPredictionPending, setIsAutoPredictionPending] = useState(false);

    const registerTrigger = useCallback((trigger: () => Promise<void>) => {
        triggerRef.current = trigger;
    }, []);

    const triggerPredictions = useCallback(async () => {
        if (triggerRef.current) {
            await triggerRef.current();
        }
    }, []);

    const notifyBoxDrawn = useCallback(() => {
        if (boxDrawnCallbackRef.current) {
            boxDrawnCallbackRef.current();
        }
    }, []);

    const value: AutoPredictionsContextType = {
        registerTrigger,
        triggerPredictions,
        notifyBoxDrawn,
        registerBoxDrawnCallback: (callback: () => void) => {
            boxDrawnCallbackRef.current = callback;
        },
        isAutoPredictionPending,
        setIsAutoPredictionPending
    };

    return (
        <AutoPredictionsContext.Provider value={value}>{children}</AutoPredictionsContext.Provider>
    );
};
